import React, { useState } from "react";
import {
    Box,
    Button,
    Grid,
    TextField,
    Typography,
} from "@mui/material";

const ExpirationDatesDropdown = ({
    activeDropdown,
    setActiveDropdown,
    onExpirationChange,
    onClearAll,

}: any) => {
    const [licenseFrom, setLicenseFrom] = useState<string>("");
    const [licenseTo, setLicenseTo] = useState<string>("");
    const [insuranceFrom, setInsuranceFrom] = useState<string>("");
    const [insuranceTo, setInsuranceTo] = useState<string>("");

    // ✅ Handle date input changes
    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, type: string) => {
        const value = event.target.value;

        if (type === "licenseFrom") setLicenseFrom(value);
        if (type === "licenseTo") setLicenseTo(value);
        if (type === "insuranceFrom") setInsuranceFrom(value);
        if (type === "insuranceTo") setInsuranceTo(value);

        // ✅ Trigger parent function when both from & to are selected
        if (type === "licenseFrom" || type === "licenseTo") {
            const newLicenseRange = {
                from: type === "licenseFrom" ? value : licenseFrom,
                to: type === "licenseTo" ? value : licenseTo,
            };
            setLicenseFrom(newLicenseRange.from);
            setLicenseTo(newLicenseRange.to);

            if (newLicenseRange.from && newLicenseRange.to) {
                onExpirationChange(newLicenseRange, "license");
            }
        }

        if (type === "insuranceFrom" || type === "insuranceTo") {
            const newInsuranceRange = {
                from: type === "insuranceFrom" ? value : insuranceFrom,
                to: type === "insuranceTo" ? value : insuranceTo,
            };
            setInsuranceFrom(newInsuranceRange.from);
            setInsuranceTo(newInsuranceRange.to);

            if (newInsuranceRange.from && newInsuranceRange.to) {
                onExpirationChange(newInsuranceRange, "insurance");
            }
        }


    };

    const handleClick = () => {
        setActiveDropdown(1);
    };

    const handleClear = () => {
        setLicenseFrom("");
        setLicenseTo("");
        setInsuranceFrom("");
        setInsuranceTo("");
        onClearAll();
        setActiveDropdown(null);

    };

    return (
        <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
            <Box onClick={handleClick} sx={styleSheet.CategoriesContainer}>
                Expiration Dates
            </Box>
            {activeDropdown == 1 && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "100%",
                        zIndex: 1,
                        width: { xs: "100%", md: 265 },
                        bgcolor: "background.paper",
                        borderRadius: "8px",
                        mt: 1,
                        p: 2,
                    }}
                >
                    <Box display={"flex"} flexDirection={"column"} gap={2} fontSize={"17px"} fontWeight={400} color={"#797979"}>
                        {/* License Expiration */}
                        <Box sx={styleSheet.InputContainer}>
                            <Typography sx={styleSheet.Label}>License Expiration</Typography>
                            <Box sx={styleSheet.InputRow}>
                                <TextField
                                    size="small"
                                    type="date"
                                    variant="outlined"
                                    sx={styleSheet.TextFieldCustom}
                                    value={licenseFrom}
                                    onChange={(e) => handleDateChange(e, "licenseFrom")}


                                />
                                <Typography sx={styleSheet.ToText}>to</Typography>
                                <TextField
                                    size="small"
                                    type="date"
                                    variant="outlined"
                                    sx={styleSheet.TextFieldCustom}
                                    value={licenseTo}
                                    onChange={(e) => handleDateChange(e, "licenseTo")}
                                    inputProps={{ min: licenseFrom }} // ✅ Restricts "To" date to be after "From"
                                />
                            </Box>
                        </Box>

                        {/* Insurance Expiration */}
                        <Box sx={styleSheet.InputContainer}>
                            <Typography sx={styleSheet.Label}>Insurance Expiration</Typography>
                            <Box sx={styleSheet.InputRow}>
                                <TextField
                                    size="small"
                                    type="date"
                                    variant="outlined"
                                    sx={styleSheet.TextFieldCustom}
                                    value={insuranceFrom}
                                    onChange={(e) => handleDateChange(e, "insuranceFrom")}

                                />
                                <Typography sx={styleSheet.ToText}>to</Typography>
                                <TextField
                                    size="small"
                                    type="date"
                                    variant="outlined"
                                    sx={styleSheet.TextFieldCustom}
                                    value={insuranceTo}
                                    onChange={(e) => handleDateChange(e, "insuranceTo")}
                                    inputProps={{ min: insuranceFrom }}
                                />
                            </Box>
                        </Box>

                        {/* Clear Button */}
                        <Box display="flex" alignItems="center" mb={2}>
                            <Button variant="outlined" onClick={handleClear}>
                                Clear
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </Grid>
    );
};

export default ExpirationDatesDropdown;

const styleSheet = {
    CategoriesContainer: {
        backgroundColor: "white",
        borderRadius: "15px",
        padding: "10px 10px",
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: "17px",
        fontWeight: "400px",
        width: "150px",
        color: "#233F91",
        fontFamily: "Atten Round New",
    },
    InputContainer: {
        display: "flex",
        flexDirection: "column",
        mb: 2,
    },
    Label: {
        color: "#797979",
        fontSize: "17px",
        fontWeight: 400,
        mb: 1,
    },
    InputRow: {
        display: "flex",
        alignItems: "center",
        gap: 1,
    },
    TextFieldCustom: {
        width: "120px",
        height: "32px",
        borderRadius: "5px",
        border: "1px solid #BFBFBF",
        "& .MuiInputBase-root": {
            height: "32px",
            fontSize: "12px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BFBFBF",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#8A8A8A",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#233F91",
        },
    },
    ToText: {
        fontSize: "14px",
        color: "#6A6A6A",
    },
};
